import { render, staticRenderFns } from "./PaymentCorrectionsHistory.vue?vue&type=template&id=63ff0b16&"
import script from "./PaymentCorrectionsHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentCorrectionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports